import latestSchema from './v4';

export default latestSchema;
